import React from "react";
import "./work.css";

const Work = () => {
  const projects = [
    {
      id: "01",
      title: "SPK Distribusi Ikan",
      description:
        "Sistem web untuk membantu menentukan prioritas distribusi pesanan ikan air tawar menggunakan metode Simple Additive Weighting.",
      tech: "PHP, MySQL, HTML, CSS, JavaScript",
    },
    {
      id: "02",
      title: "Website Undangan Online",
      description:
        "Template undangan digital berbasis website dengan tampilan modern dan animasi scroll.",
      tech: "HTML, CSS, JavaScript",
    },
    {
      id: "03",
      title: "Ziiquatic",
      description:
        "Konsep bisnis dekorasi aquarium laut dengan pendekatan visual branding dan promosi digital.",
      tech: "Branding, Design, Social Media",
    },
    {
      id: "04",
      title: "Personal Portfolio Website",
      description:
        "Website portfolio pribadi berbasis React dengan konsep dark minimalist aesthetic.",
      tech: "React, CSS, JavaScript",
    },
  ];

  return (
    <section className="work" id="work">
      <div className="work__title">
        <div className="work__typography">
          <h2>selected work</h2>
          <h2>selected work</h2>
          <h2>selected work</h2>
        </div>
      </div>
      <div className="work__container">
        <div className="work__list">
          {projects.map((project) => (
            <div className="work__item-list" key={project.id}>
              <div className="work__item-number">{project.id}</div>
              <div className="work__item-details">
                <h3 className="work__item-title">{project.title}</h3>
                <p className="work__item-desc">{project.description}</p>
                <p className="work__item-tech">{project.tech}</p>
              </div>
              <div className="work__item-action">
                <button
                  className="work__btn-preview"
                  onClick={(e) => {
                    e.preventDefault();
                    alert("Project detail is coming soon!");
                  }}
                >
                  <i className="uil uil-arrow-up-right"></i> Details
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
